import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { blobTypeStoreReadSettingsAdapts } from './blob-type-store-read-settings.adapter';
import { OracleCloudStorageStoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/oracle-cloud-storage-store-read-settings';
import { AmazonS3StoreReadSettingsAdapter } from './s3-store-read-settings.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OracleCloudStorageStoreReadSettings),
    asynchronous: true,
    adapts: {
        ...blobTypeStoreReadSettingsAdapts,
        deleteFilesAfterCompletion: '*',
        prefix: '*'
    }
})
export class OracleCloudStorageStoreReadSettingsAdapter extends AmazonS3StoreReadSettingsAdapter {}
